import isIE from 'services/isIE';
import 'services/replaceWithPolyfill';

const lineBreak = () => {
  const _ = document.createElement('span');
  _.style.display = 'block';
  _.style.visibility = 'hidden';
  _.innerHTML = '&#65279;';

  return _;
};

const updateReadOnlyText = containerElement => {
  if (!containerElement) {
    return;
  }

  Array.from(containerElement.querySelectorAll('.chameleon-text *')).forEach(
    (entry: any) => {
      // if entry is not a span ( indicating a mark )
      // and entry is ' empty '
      if (
        entry.tagName.toLowerCase() !== 'span' &&
        !entry.innerText.toString()
      ) {
        entry.replaceWith(lineBreak());
      }

      if (['h1', 'h2', 'h3'].includes(entry.tagName.toLowerCase())) {
        const pTags = Array.from(entry.querySelectorAll('p'));
        pTags.forEach((p: any) => {
          if (p.innerText.toString()) {
            // old. no line breaks
            //
            // p.outerHTML = p.outerHTML.replace(
            //   /\<p data-type=\"paragraph\"\>|\<\/p\>/g,
            //   ''
            // );

            p.outerHTML = p.outerHTML
              .replace(/\<p data-type=\"paragraph\"\>/g, '')
              .replace(/\<\/p\>/g, '<br>');
          }
        });
      }

      if (entry.dataset.type === 'indent') {
        const closestLi = entry.closest('li');

        if (closestLi) {
          closestLi.classList.add('indent');
        } else {
          entry.classList.add('indent-alt');
        }
      }

      if (entry.tagName.toLowerCase() === 'li') {
      }

      if (entry.tagName.toLowerCase() === 'a') {
        const spans = Array.from(entry.querySelectorAll('span'));
        const localColor: any = spans.find((span: any) => {
          return span.style.color;
        });

        if (localColor && localColor.style.color) {
          entry.style.textDecorationColor = localColor.style.color;
        }
      }

      if (isIE()) {
        if (entry.style.fontFamily === '') entry.style.fontFamily = '';
      }
    }
  );
};

export default updateReadOnlyText;
